// import { isIp } from "is-ip";
import { parseCronSchedule } from "../../services/utils";
import { defaultValues } from "../../services/defaults";

export const validationFns = (label: string = "Value") => {
  const showRegex = true;

  return {
    // customAsync: async (value: any, values: any) => {
    //   await sleep(2);
    //   return true;
    // },
    required: (value: any) => {
      if (!value) {
        return `${label} is required`;
      }
      return true;
    },
    name: (value: string) => {
      if (!value) {
        return true;
      }

      if (value.length > 64) return `${label} must be less than 64 characters`;

      let pattern = /^[a-z]([-a-z0-9])*[a-z0-9]$/;
      if (pattern.test(value) === false) {
        if (showRegex) {
          return `${label} does not satisfy regex ${pattern}`;
        }
        return `${label} is invalid`;
      }

      return true;
    },
    description: (value: string) => {
      if (!value) {
        return true;
      }

      if (value.length > 250) return `${label} must be less than 64 characters`;

      return true;
    },
    uuid: (value: string) => {
      if (!value) {
        return true;
      }

      let pattern = /[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}/;
      if (pattern.test(value) === false) {
        if (showRegex) {
          return `${label} does not satisfy regex ${pattern}`;
        }
        return `${label} must be UUID`;
      }

      return true;
    },
    https: (value: string) => {
      if (!value) {
        return true;
      }

      if (!value.startsWith(`https://`)) return `${label} must have https:// scheme`;

      return true;
    },
    number: (value: string) => {
      value = String(value);
      if (!value) {
        return true;
      }

      // for scientific numbers
      if (value.includes("e")) {
        return `${label} must be a number`;
      }

      if (Number.isNaN(Number(value))) {
        return `${label} must be a number`;
      }

      return true;
    },
    minNumber: (limit: number) => (value: string) => {
      value = String(value);
      if (!value) {
        return true;
      }

      // for scientific numbers
      if (value.includes("e")) {
        return `${label} must be a number`;
      }

      if (Number.isNaN(Number(value))) {
        return `${label} must be a number`;
      }

      const valueNumber = Number(value);
      if (valueNumber < limit) {
        return `${label} must be at least ${limit}`;
      }

      return true;
    },
    maxNumber: (limit: number) => (value: string) => {
      value = String(value);
      if (!value) {
        return true;
      }

      // for scientific numbers
      if (value.includes("e")) {
        return `${label} must be a number`;
      }

      if (Number.isNaN(Number(value))) {
        return `${label} must be a number`;
      }

      const valueNumber = Number(value);
      if (valueNumber > limit) {
        return `${label} can be at most ${limit}`;
      }

      return true;
    },
    minLength: (limit: number) => (value: string) => {
      value = String(value);
      if (!value) {
        return true;
      }

      if (value.length < limit) {
        return `${label} must be at least ${limit} characters long`;
      }

      return true;
    },
    maxLength: (limit: number) => (value: string) => {
      value = String(value);
      if (!value) {
        return true;
      }

      if (value.length > limit) {
        return `${label} can be at most ${limit} characters long`;
      }

      return true;
    },
    email: (value: string) => {
      if (!value) {
        return true;
      }

      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let pattern = emailRegex;
      if (pattern.test(value) === false) {
        return `${label} is not a valid email address`;
      }

      return true;
    },
    envVar: {
      name: (value: string) => {
        if (!value) {
          return true;
        }

        if (value.startsWith("CPLN_")) {
          return `Values starting with CPLN_ are reserved internally`;
        }
        if (["K_SERVICE", "K_CONFIGURATION", "K_REVISION"].includes(value)) {
          return `${value} is reserved internally`;
        }

        let pattern = /^[-._a-zA-Z][-._a-zA-Z0-9]*$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        if (value.length > 120) {
          return `${label} can be at most 120 characters`;
        }
        return true;
      },
    },
    cloudaccount: {
      awsAccountId: (value: string) => {
        if (!value) {
          return true;
        }

        let pattern = /^\d{12}$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
      awsRoleArn: (value: string) => {
        if (!value) {
          return true;
        }

        let pattern = /^arn:.*/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
      gcpProjectId: (value: string) => {
        if (!value) {
          return true;
        }

        if (value.length < 6) {
          return `${label} must be at least 6 characters`;
        }
        if (value.length > 30) {
          return `${label} can be 30 characters at most`;
        }

        let pattern = /[a-z]([a-z]|-|[0-9])+/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
      azureStorageAccountName: (value: string) => {
        if (!value) {
          return true;
        }

        let pattern = /^[a-z0-9]{3,24}$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
      azureResourceGroupName: (value: string) => {
        if (!value) {
          return true;
        }

        let pattern = /^[-\w\._\(\)]+$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
    },
    volumeset: {
      storageClassSuffix: (value: string) => {
        if (!value) {
          return true;
        }

        let pattern = /^[a-zA-Z][0-9a-zA-Z\-_]*$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid`;
        }

        return true;
      },
      schedule: (value) => {
        if (!value) {
          return true;
        }

        try {
          let parsed = parseCronSchedule(value);
          if (
            parsed.minuteSegments.length > 1 ||
            parsed.minuteSegments[0].wildcard ||
            parsed.minuteSegments[0].absoluteRangeMax != parsed.minuteSegments[0].absoluteRangeMin
          ) {
            return "Snapshots cannot be scheduled more frequently than once an hour";
          }
        } catch (e) {
          return e.message;
        }
        return true;
      },
    },
    workload: {
      name: (value: string) => {
        if (!value) {
          return true;
        }

        if (value.length > 49) return `${label} must be less than 64 characters.`;

        let pattern = /^[a-z]([-a-z0-9])*[a-z0-9]$/;
        if (pattern.test(value) === false) {
          if (showRegex) {
            return `${label} does not satisfy regex ${pattern}`;
          }
          return `${label} is invalid.`;
        }
        return true;
      },
      container: {
        name: (value: string) => {
          if (!value) {
            return true;
          }

          if (value.startsWith("cpln-")) return `${label} cannot start with cpln-`;
          if (value.startsWith("debugger-")) return `${label} cannot start with debugger-`;
          if (["istio-proxy", "queue-proxy", "istio-validation"].includes(value))
            return `${label} cannot be a reserved value ("istio-proxy", "queue-proxy", "istio-validation")`;
          return true;
        },
        port: (value: string) => {
          if (!value) {
            return true;
          }

          const port = Number(value);
          if (Number.isNaN(port)) {
            return `${label} must be a number`;
          }

          const reserved = [8012, 8022, 9090, 9091, 15000, 15001, 15006, 15020, 15021, 15090, 41000];
          if (reserved.includes(port)) {
            return `${label} cannot be a reserved value`;
          }

          return true;
        },
      },
      firewall: {
        cidr: (value: string) => {
          if (!value) {
            return true;
          }

          let isArray: false | "comma" | "space" = false;
          if (value.trim().includes(",")) {
            isArray = "comma";
          } else if (value.trim().includes(" ")) {
            isArray = "space";
          }
          let arrayToCheck: string[] = [];
          if (isArray) {
            arrayToCheck = value
              .trim()
              .split(isArray === "comma" ? "," : " ")
              .map((x) => x.trim())
              .filter(Boolean);
          } else {
            arrayToCheck.push(value.trim());
          }
          for (const item of arrayToCheck) {
            const res = isValid(item);
            if (res !== true) {
              return res;
            }
          }
          return true;

          function isValid(value: string) {
            const valueIp = value.split("/").shift();
            const valueCIDR = value.split("/").length > 1 ? value.split("/").pop() : "";
            // TODO fix isIp
            // let ipVersion = isIp.version(valueIp);
            // if (!ipVersion) return `${label} is invalid IP`;
            const minCIDR = 0;
            // let maxCIDR = ipVersion === 4 ? 32 : 128;
            if (!valueCIDR) return true;
            const numberCIDR = Number(valueCIDR);
            if (Number.isNaN(numberCIDR)) return `${label} is invalid CIDR`;
            if (numberCIDR < minCIDR) return `${label} is invalid CIDR`;
            // if (numberCIDR > maxCIDR) return `${label} is invalid CIDR`;
            return true;
          }
        },
      },
    },
    secret: {
      aws: {
        accessKey: (value: string) => {
          if (!value) {
            return true;
          }

          let pattern = /^AKIA.*/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
        roleArn: (value: string) => {
          if (!value) {
            return true;
          }

          let pattern = /^arn:.*/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
      },
      dictionary: {
        key: (value: string) => {
          if (!value) {
            return true;
          }

          let pattern = /^[-._a-zA-Z0-9]+$/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
      },
      nats: {
        accountId: (value: string) => {
          if (!value) {
            return true;
          }
          let pattern = /^A[A-Z0-9]{55}$/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
        privateKey: (value: string) => {
          if (!value) {
            return true;
          }

          let pattern = /^SA[A-Z0-9]{56}$/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
      },
    },
    org: {
      logging: {
        cloudWatch: {
          retentionDays: (value: string) => {
            if (!value) {
              return true;
            }

            const options = defaultValues.org.logging.cloudWatch.retentionDays.options.map((v) => String(v));
            if (!options.includes(value)) {
              return `Value must be one of '${options.join(", ")}'`;
            }
            return true;
          },
        },
        elastic: {
          aws: {
            host: (value: string) => {
              if (!value) {
                return true;
              }

              if (!value.endsWith("es.amazonaws.com")) {
                return `The host "${value}" doesn't look like a valid AWS ElasticSearch host, should end with es.amazonaws.com`;
              }

              return true;
            },
          },
          generic: {
            path: (value: string) => {
              if (!value) {
                return true;
              }

              let pattern = /^\//;
              if (pattern.test(value) === false) {
                if (showRegex) {
                  return `${label} does not satisfy regex ${pattern}`;
                }
                return `${label} is invalid.`;
              }
              return true;
            },
          },
        },
      },
      security: {
        threatDetection: {
          syslog: {
            host: {
              path: (value: string) => {
                if (!value) {
                  return true;
                }

                let pattern = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))*$/;
                if (pattern.test(value) === false) {
                  if (showRegex) {
                    return `${label} does not satisfy regex ${pattern}`;
                  }
                  return `${label} is invalid.`;
                }
                return true;
              },
            },
          },
        },
      },
    },
    identity: {
      nats: {
        ttl: (value: string) => {
          if (!value) {
            return true;
          }

          let pattern = /^[0-9]+(ms|s|m|h)$/;
          if (pattern.test(value) === false) {
            if (showRegex) {
              return `${label} does not satisfy regex ${pattern}`;
            }
            return `${label} is invalid.`;
          }
          return true;
        },
      },
    },
    // below here is not processed
    url: [
      (value) => {
        if (!value.match(/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i)) return `${label} must be a URL.`;
        return true;
      },
    ],
    domain: [
      (value) => {
        if (value.length > 256) {
          return `${label} is invalid.`;
        }

        const segments = value.split(".");
        for (let i = 0; i < segments.length; ++i) {
          const segment = segments[i];
          if (!segment.length) {
            return `${label} is invalid.`;
          }
        }

        return true;
      },
      (value) => {
        const minDomainSegments = 2;
        const segments = value.split(".");
        if (segments.length < minDomainSegments) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    domainWithoutPattern: [
      // domain copy start
      (value) => {
        if (value.length > 256) {
          return `${label} is invalid.`;
        }

        const segments = value.split(".");
        for (let i = 0; i < segments.length; ++i) {
          const segment = segments[i];
          if (!segment.length) {
            return `${label} is invalid.`;
          }
        }

        return true;
      },
      (value) => {
        const minDomainSegments = 2;
        const segments = value.split(".");
        if (segments.length < minDomainSegments) {
          return `${label} is invalid.`;
        }
        return true;
      },
      // domain copy end
      (value) => {
        if (value.includes("*")) {
          return `${label} cannot have wildcard`;
        }

        return true;
      },
    ],
    subDomain: [
      (value) => {
        if (value.length > 256) {
          return `${label} is invalid.`;
        }

        const segments = value.split(".");

        for (let i = 0; i < segments.length; ++i) {
          const segment = segments[i];
          if (!segment.length) {
            return `${label} is invalid.`;
          }
        }

        return true;
      },
      (value) => {
        const minDomainSegments = 3;
        const segments = value.split(".");
        if (segments.length < minDomainSegments) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    ipv4: [
      (value) => {
        const valueIp = value.split("/").shift();
        // TODO fix isip
        // let ipVersion = isIp.version(valueIp);
        // if (!ipVersion) return "Invalid IP";
        // if (String(ipVersion) !== "4") return "Invalid IP.";
        return true;
      },
    ],
    hostname: [
      (value) => {
        const dnsRegex = /^(?![0-9]+$)(?!.*-$)([*]?)(?!-)[a-z0-9-.]+$/;
        if (value.match(dnsRegex)) return true;
        return `${label} is invalid.`;
      },
    ],
    deleteString: [
      (value) => {
        if (value !== "delete") return `${label} must be "delete".`;
        return true;
      },
    ],
    awsAccessKey: [
      (value) => {
        if (!value.match(/^AKIA.*/)) {
          return "Access Key is invalid.";
        }
        return true;
      },
    ],
    awsRoleArn: [
      (value) => {
        if (!value.match(/^arn:.*/)) {
          return "Role Arn is invalid.";
        }
        return true;
      },
    ],
    awsRoleName: [
      (value) => {
        if (!value.match(/^([a-zA-Z0-9/+=,.@_-])+$/)) {
          return "Role Name is invalid.";
        }
        return true;
      },
    ],
    awsPolicyRef: [
      (value) => {
        if (!value.match(/^(aws::)?([a-zA-Z0-9/+=,.@_-])+$/)) {
          return "Policy Ref is invalid.";
        }
        return true;
      },
    ],
    awsAccountId: [
      (value) => {
        if (!value.match(/^\d{12}$/)) return `AWS Account Id is invalid.`;
        return true;
      },
    ],
    ecrRepo: [
      (value) => {
        try {
          const knownRegions = [
            "ap-northeast-1",
            "ap-northeast-2",
            "ap-northeast-3",
            "ap-south-1",
            "ap-southeast-1",
            "ap-southeast-2",
            "ca-central-1",
            "eu-central-1",
            "eu-north-1",
            "eu-west-1",
            "eu-west-2",
            "eu-west-3",
            "sa-east-1",
            "us-east-1",
            "us-east-2",
            "us-west-1",
            "us-west-2",
          ];

          const url = new URL("https://" + value);
          const parts = url.hostname.split(".");
          switch (true) {
            case parts.length != 6:
            case !/[0-9]{12}/.test(parts[0]):
            case parts[1] != "dkr":
            case parts[2] != "ecr":
            case !knownRegions.includes(parts[3]):
            case parts[4] != "amazonaws":
            case parts[5] != "com":
              return `Not valid. Example: ACCOUNT_ID.dkr.ecr.REGION.amazonaws.com/REPO`;
            default:
              return true;
          }
        } catch (e) {
          return `Not valid. Example: ACCOUNT_ID.dkr.ecr.REGION.amazonaws.com/REPO`;
        }
      },
    ],
    base64: [
      (value) => {
        if (value.length < 1) return true;
        const regex = /^[A-Za-z0-9+/\r\n]+={0,2}$/;
        if (value.match(regex)) return true;
        return "Value is not base64.";
      },
    ],
    gcpProjectId: [
      (value) => {
        if (value.length < 6) return `${label} must be at least 6 characters.`;
        if (value.match(/[a-z]([a-z]|-|[0-9])+/)) return true;
        return `${label} is invalid.`;
      },
    ],
    gcpServiceAccount: [
      (value) => {
        if (!value.match(/^.*\.gserviceaccount\.com$/)) {
          return `Service Account is invalid.`;
        }
        return true;
      },
    ],
    gcpRoleName: [
      (value) => {
        if (!value.match(/^roles\/([a-zA-Z0-9])+(\.([a-zA-Z0-9])+)?$/)) {
          return `Role Name is invalid.`;
        }
        return true;
      },
    ],
    identityNetworkResourceServiceName: [
      (value) => {
        let nameRes: string | true = true;
        let domainRes: string | true = true;
        if (value.length > 64) nameRes = `${label} must be less than 64 characters.`;
        if (/^[a-z][-a-z0-9]([-a-z0-9])*[a-z0-9]$/.test(value) === false) {
          nameRes = `${label} is invalid.`;
        }

        if (value.length > 256) {
          domainRes = `${label} is invalid.`;
        }

        const segments = value.split(".");
        for (let i = 0; i < segments.length; ++i) {
          const segment = segments[i];
          if (!segment.length) {
            domainRes = `${label} is invalid.`;
          }
        }

        const minDomainSegments = 2;
        if (segments.length < minDomainSegments) {
          domainRes = `${label} is invalid.`;
        }

        if (nameRes === true || domainRes === true) {
          return true;
        }
        return nameRes || domainRes;
      },
    ],
    workingDir: [
      (value) => {
        // TODO fix with better libs
        // try {
        //   const normalized = pathNormalize(value);
        //   if (!pathIsAbsolute(normalized)) {
        //     return `${label} must be an absolute path.`;
        //   }
        // } catch (e) {
        //   console.error("validation workingDir failed", e.message);
        //   return `${label} is invalid.`;
        // }
        return true;
      },
    ],
    azureResourceGroupName: [
      (value) => {
        const regex = /^[-\w\._\(\)]+$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    azureStorageAccountName: [
      (value) => {
        const regex = /^[a-z0-9]{3,24}$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    memoryResource: [
      (value) => {
        const regex = /^([+-]?[0-9.]+)([eEinumkKMGTP]*[-+]?[0-9]*)$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    awsPrivateLinkEndpointServiceName: [
      (value) => {
        const regex = /^com\.amazonaws\.vpce\.[^.]+.vpce-.+$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    gcpServiceConnectTargetService: [
      (value) => {
        // example: projects/coke-267310/regions/us-east1/serviceAttachments/my-service
        const regex = /^\/?projects\/(.+)\/regions\/(.+)\/serviceAttachments\/(.+)\/?$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    domainRoutePrefix: [
      (value) => {
        if (value === "/") return true;
        const regex = /^\/[0-9a-zA-Z-\._~\/]*$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    domainRouteHostPrefix: [
      (value) => {
        const regex = /^[0-9a-zA-Z-\._]*$/;
        if (value.match(regex)) return true;
        return `${label} is invalid.`;
      },
    ],
    jobSchedule: [
      (value) => {
        if (value.trim().length < 1) {
          return "Schedule is required";
        }

        if (
          !value.match(
            /^(((\*(\/\d+)?)|(\d+(-\d+)?))(,((\*(\/\d+)?)|(\d+(-\d+)?)))*)(\s(((\*(\/\d+)?)|(\d+(-\d+)?))(,((\*(\/\d+)?)|(\d+(-\d+)?)))*)){4}$/,
          )
        ) {
          return `${label} is not in standard cron format.`;
        }
        const pieces = value.split(/\s+/);
        if (pieces.length != 5) {
          return `${label} requires 5 sections.`;
        }

        // const errorMsg = checkCronValues(value);
        // if (errorMsg) {
        //   return errorMsg;
        // }
        return true;
      },
    ],
    coralogix: [
      (value) => {
        try {
          const patterns = ["{org}", "{gvc}", "{workload}", "{location}"];
          const matchAll = value.matchAll(/\{.+?\}/g);
          let match = matchAll.next();

          do {
            if (match.value && !patterns.includes(match.value[0])) {
              return `The pattern contains unsupported var ${match.value}`;
            }
            match = matchAll.next();
          } while (!match.done);

          return true;
        } catch (e) {
          return true;
        }
      },
    ],
    natsAccountId: [
      (value) => {
        if (value.length < 1) return `${label} is invalid.`;
        if (value.match(/^A[A-Z0-9]{55}$/)) return true;
        return `${label} is invalid.`;
      },
    ],
    natsPrivateKey: [
      (value) => {
        if (value.length < 1) return `${label} is invalid.`;
        if (value.match(/^SA[A-Z0-9]{56}$/)) return true;
        return `${label} is invalid.`;
      },
    ],
    ngsPubSub: [
      (value) => {
        if (value.length < 1) return `${label} is invalid.`;
        const fwc = ">";
        const tsep = ".";

        let sfwc = false;
        const tokens = value.split(tsep);

        for (let t of tokens) {
          const length = t.length;
          if (length == 0 || sfwc) {
            return `${label} is invalid.`;
          }
          if (length > 1) {
            if (/\t\n\f\r /.test(t)) {
              return `${label} is invalid.`;
            }
            continue;
          }

          switch (t[0]) {
            case fwc:
              sfwc = true;
              continue;
            case " ":
            case "\t":
            case "\n":
            case "\r":
            case "\f":
              return `${label} is invalid.`;
          }
        }
        return true;
      },
    ],
    ngsTTL: [
      (value) => {
        if (value.match(/^[0-9]+(ms|s|m|h)$/)) return true;
        return `${label} is invalid.`;
      },
    ],
    // number: [
    //   // -1 limit is hardcoded, make it customizable when needed
    //   (value) => {
    //     for (let charIndexStr in value.split("")) {
    //       const charIndex = Number(charIndexStr);
    //       const char = value[charIndex];
    //       if (char === "-" && charIndex === 0) {
    //         if (value.length < 2) {
    //           return `${label} must be a number.`;
    //         }
    //         continue;
    //       }
    //       const charNumber = Number(char);
    //       if (Number.isNaN(charNumber)) {
    //         return `${label} must be a number.`;
    //       }
    //     }
    //     if (value) {
    //       const n = Number(value);
    //       if (n < -1) {
    //         return `${label} must be at least -1.`;
    //       }
    //     }
    //     return true;
    //   },
    // ],
    port: [
      (value) => {
        const reservedPorts = [8012, 8022, 9090, 9091, 15000, 15001, 15006, 15020, 15021, 15090, 41000];
        const valueNumber = Number(value);
        const valueIsNaN = Number.isNaN(valueNumber);
        if (valueIsNaN) {
          return `${label} must be a number.`;
        }
        if (reservedPorts.includes(valueNumber)) {
          return `Port is reserved.`;
        }
        return true;
      },
    ],
    tracingSampling: [
      (value) => {
        const valueNumber = Number(value);
        if (Number.isNaN(valueNumber)) {
          return `${label} must be a number.`;
        }
        if (valueNumber < 0) {
          return `${label} must be 0 or higher.`;
        }
        if (valueNumber < 0) {
          return `${label} must be 100 or fewer.`;
        }
        if (value.includes(".")) {
          const precisionPart = value.split(".")[1];
          if (precisionPart.length > 2) {
            return `Precision can be 2 at most. Ex: 1.23, 7.59`;
          }
        }
        return true;
      },
    ],
    emailAccountPassword: [
      (value) => {
        if (value.length < 8) {
          return `Must be at least 8 characters.`;
        }
        return true;
      },
      // (value) => {
      //   let hasLowercaseLetter = false;
      //   for (const letter of value) {
      //     if (
      //       getLetters()
      //         .map((l) => l.toLowerCase())
      //         .includes(letter)
      //     ) {
      //       hasLowercaseLetter = true;
      //     }
      //   }
      //   if (!hasLowercaseLetter) {
      //     return "Must have a lowercase letter";
      //   }
      //   return true;
      // },
      // (value) => {
      //   let hasUppercaseLetter = false;
      //   for (const letter of value) {
      //     if (
      //       getLetters()
      //         .map((l) => l.toUpperCase())
      //         .includes(letter)
      //     ) {
      //       hasUppercaseLetter = true;
      //     }
      //   }
      //   if (!hasUppercaseLetter) {
      //     return "Must have an uppercase letter";
      //   }
      //   return true;
      // },
      // (value) => {
      //   let hasNumber = false;
      //   for (const letter of value) {
      //     if (
      //       getNumbers()
      //         .map((n) => n.toString())
      //         .includes(letter)
      //     ) {
      //       hasNumber = true;
      //     }
      //   }
      //   if (!hasNumber) {
      //     return "Must have a number";
      //   }
      //   return true;
      // },
    ],
    labelTaintKey: [
      (value) => {
        // TODO not used
        if (value.length < 1) return `${label} is Required.`;
        if (/^[a-z][-a-z0-9]([-a-z0-9])*[a-z0-9]$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    labelTaintValue: [
      (value) => {
        // TODO not used
        if (value.length < 1) return `${label} is Required.`;
        if (/^[a-z][-a-z0-9]([-a-z0-9])*[a-z0-9]$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    nodePoolName: [
      (value) => {
        if (value.length < 1) return `${label} is Required.`;
        if (/^([A-Za-z0-9][-A-Za-z0-9_.]*)?[A-Za-z0-9]$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsDeployRoleArn: [
      (value) => {
        if (/^arn:(aws):iam::[0-9]+:role\/.+$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsEFSRoleArn: [
      (value) => {
        if (/^arn:(aws):iam::[0-9]+:role\/.+/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsAmiExact: [
      (value) => {
        if (/^(ami-[0-9a-f]+)$|^(resolve:ssm:.+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsSecurityGroup: [
      (value) => {
        if (/^(sg-[a-f0-9]+)$|^(resolve:ssm:.+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsSubnet: [
      (value) => {
        if (/^(subnet-[a-f0-9]+)$|^(resolve:ssm:.+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsVpcId: [
      (value) => {
        if (/^(vpc-[a-f0-9]+)$|^(resolve:ssm:.+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsDiskEncryptionKeyArn: [
      (value) => {
        if (/^(arn:aws:kms:.+)$|^(resolve:ssm:.+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    goDuration: [
      (value) => {
        if (/^(\d+(?:\.\d+)?)([hms]+)$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    storageClassSuffix: [
      (value) => {
        if (/^[a-zA-Z][0-9a-zA-Z\-_]*$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sAwsTags: [
      (value) => {
        if (/^[ a-zA-Z0-9=_+:./@-]+$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sHetznerLabelsKey: [
      (value) => {
        if (/^[a-zA-Z0-9/_-]+$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    mk8sHetznerFloatingIpValidLabel: [
      (value) => {
        if (value.includes(",")) {
          return `Item cannot contain ,`;
        }

        if (value.includes("=")) {
          return `Item cannot contain =`;
        }

        return true;
      },
    ],
    mk8sTritonTagsKey: [
      (value) => {
        if (/^[a-zA-Z0-9_.-]+$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        if (value.length < 1) {
          return `Key must be at least 1 character.`;
        }
        if (value.length > 63) {
          return `Key must be at most 63 character.`;
        }

        return true;
      },
    ],
    mk8sTritonTagsValue: [
      (value) => {
        if (value.length > 255) {
          return `Key must be at most 255 character.`;
        }

        return true;
      },
    ],
    envoyDurationString: [
      (value) => {
        if (/^\d+(?:\.\d+)?s$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    re2: [
      (value) => {
        if (/^(?!.*\\$)(?!.*\[[^\]]*$)(?!.*\([^)]*$)(?!.*\{[^}]*$)[\s\S]+$/.test(value) === false) {
          return `${label} is invalid.`;
        }
        return true;
      },
    ],
    tritonExternalSyslog: [
      (value) => {
        const parts = value.split(":");

        // Must have exactly one colon
        if (parts.length !== 2) {
          return `Must be in format host:port`;
        }

        const [host, portStr] = parts;

        // Validate host is not empty
        if (!host || host.trim().length === 0) {
          return `Host cannot be empty`;
        }

        // Validate port is a number
        const port = parseInt(portStr, 10);
        if (isNaN(port) || portStr !== port.toString()) {
          return `Port must be a valid number`;
        }

        // Validate port range
        if (port < 1 || port > 65535) {
          return `Port must be between 1 and 65535`;
        }

        // Optional: Basic host format validation (allows hostnames and IPs)
        if (host.includes(" ") || host.startsWith(".") || host.endsWith(".")) {
          return `Invalid host format`;
        }

        return true;
      },
    ],
  };
};
